import React from "react"

const DrawerBody = ({ children }) => {
    return <div className="drawer__body h-custom-scrollbar">{children}</div>
}

export default DrawerBody
